import { Component, OnInit } from '@angular/core';
import { ApiUrls } from '../../apiRouts';
import { MainService } from '../../service/main.service';
import { LocalStorageService } from '../../service/local-storage.service';
import { ToasterServiceService } from '../../service/toaster.service';

@Component({
  selector: 'app-notification-list',
  templateUrl: './notification-list.component.html',
  styleUrl: './notification-list.component.scss'
})
export class NotificationListComponent implements OnInit {
  notificationList: any = [];
  userId: any;
  notificationListLength: any;

  constructor(
    private mainService: MainService,
    private toasterService: ToasterServiceService,
    private localStorageService: LocalStorageService) {
    this.userId = JSON.parse(this.localStorageService.getItem("loginData") || '{}').user_id;
  }

  ngOnInit(): void {
    this.getNotificationList();
  }

  getNotificationList() {
    this.mainService.getApi(ApiUrls.getNotification + this.userId).subscribe((res: any) => {
      if (res.status == 1) {
        this.notificationList = res.notification;
      }
    });
  }
  notificationIsRead(member: any) {
    let data = {
      notification_id: member.notification_id,
      notification_title: "",
      description: "",
      created_by: 0,
      to_user_type_id: 0,
      Action: 'ISREAD',
    };
    this.mainService.postApi(ApiUrls.addNotification, data, 1).subscribe((res: any) => {
      if (res.status == 1) {
        this.mainService.triggerProfileData(1);
      } else {
        this.toasterService.toastError(res.response);
      }
    })
  }
}
